<template>
  <div class="modal-overlay">
    <div class="context">
      <p>Do you want to {{ verb }} this {{ subject }}?</p>
      <div class="buttons">
        <button @click="modalAction('yes')">Yes</button>
        <button @click="modalAction('no')">No</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalAction',
  props: ['verb', 'subject'],
  methods: {
    modalAction(value) {
      this.$emit('modalAction', value);
    },
  },
};
</script>

<style scoped>
  .modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 20;
    background: rgba(20, 20, 20, 0.83);
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
  }
  .modal-overlay .context {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 21;
    width: 100%;
    height: 100%;
    background: var(--white);
    max-width: 721px;
    max-height: 300px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .modal-overlay .context p {
    font-family: montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 28px;
    line-height: 34px;
    color: #2f2e41;
    margin-bottom: 40px;
    text-align: center;
  }
  .modal-overlay .context .buttons > button {
    border-radius: 5px;
  }
  .modal-overlay .context .buttons :nth-child(1) {
    width: 127px;
    height: 50px;
    left: 804px;
    top: 725px;
    background: var(--colorPrimary);
    box-shadow: 0px 9px 29px rgba(26, 107, 158, 0.1);
    color: var(--white);
    margin-right: 40px;
  }
  .modal-overlay .context .buttons :nth-child(2) {
    width: 127px;
    height: 50px;
    left: 988px;
    top: 725px;
    color: var(--colorPrimary);
    border: 1px solid #025fa0

  }
</style>
